// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__KqMNV","header":"Messages_header__v9CBT"};